 const ROLES = {
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
  TEACHER: "teacher",
  STUDENT: "student",
  ALL: ["admin", "teacher", "student", "super_admin"],
};

export default ROLES;